import React, { useState } from "react"
import FileInput from "../../components/form/FileInput";
import BaseModalAnimated from "../../components/modal/BaseModalAnimated";
import { showFormErrors } from "../../helpers/showFormErrors";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "../../components/form/CustomInput";
import CustomButton from "../../components/form/CustomButton";
import { evidencesResource } from "../../helpers/configRoutes/backend_helper";

const EvidenceUpdateModal = ({ modal, setModal, filters, setFilters, modalFather, setModalFather }) => {
    const [type, setType] = useState(false)
    const [loading, setLoading] = useState(false)
    const validationDocument = useFormik({
        enableReinitialize: true,
        initialValues: { ...modal.item },
        validationSchema: Yup.object({
            document: Yup.string().nullable(),
            description: Yup.string().required('Description'),
        }),
        onSubmit: async (values, { setErrors, resetForm }) => {
            setLoading(true)
            const response = await evidencesResource('put',values,values.id)
            if(response.status){
                setLoading(false)
                
                setFilters({...filters,show:filters.show})
                setModal({ ...modal, show: false })
                setModalFather({...modalFather,show:false})
                //resetForm()
            }
            //setLoading(false)
        }
    });

    const onCloseModal = () => {
        setModal({...modal,show:false,item:{}})
    }

    return (
        <BaseModalAnimated modal={modal} setModal={setModal} onCloseModal={onCloseModal}>
            <div className="grid grid-cols-2 gap-4 p-2">
                <div className="grid grid-cols-2">
                    <FileInput
                        validation={validationDocument}
                        format={'pdf'}
                        name={'document'}
                        nameInput={"Evidence"}
                    >
                        <div
                            className={`p-2 rounded-full ${(modal.type === 'pdf' && modal.show) ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-blue-400`}
                            onClick={() => setModal({ ...modal, type: 'pdf' })}
                        >
                            <i className="fas fa-file-alt text-lg"></i>
                        </div>
                        <span className="text-xs mt-1">Documentos</span>
                    </FileInput>
                    <FileInput
                        validation={validationDocument}
                        format={'img'}
                        name={'document'}
                        nameInput={"Evidence"}
                    >
                        <div
                            className={`p-2 rounded-full ${(modal.type === 'img' && modal.show) ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-blue-400`}
                            onClick={() => setModal({ ...modal, type: 'img' })}
                        >
                            <i className="fas fa-image text-lg"></i>
                        </div>
                        <span className="text-xs mt-1">Imágenes</span>
                    </FileInput>
                </div>

                <CustomInput
                    label="Description"
                    type="text"
                    name="description"
                    labelClassName="text-[14px] text-[#ADADAD] whitespace-nowrap"
                    error={validationDocument?.errors?.description}
                    value={validationDocument?.values?.description}
                    handleChange={validationDocument.handleChange}
                />
            </div>
            <div className="flex items-center justify-center p-6 rounded-b border-slate-200">
                <CustomButton
                    loading={loading}
                    textLoad={'uploading'}
                    type={"button"}
                    onClick={() => [validationDocument.handleSubmit(), showFormErrors(validationDocument)]}
                    className="w-full lg:w-[30%]"
                >
                    Update Evidence
                </CustomButton>
            </div>

        </BaseModalAnimated >
    )
}

export default EvidenceUpdateModal